import { graphql } from "../gql";

export const getUniqueRevCodesQueryDoc = graphql(`
  query getUniqueRevCodes($includes: String!) {
    uniqueRevCodes(filter: { includes: $includes }) {
      nodes
    }
  }
`);
